[
  {
    "label": "documentNo",
    "displayLabel": "Shipping Bill No",
    "editable": false
  },
  {
    "label": "pcinNo",
    "displayLabel": "PCIN Number",
    "editable": true,
    "placeholder": "Enter PCIN Number",
    "fieldInfo": {
      "dataType": "string"
    }
  },
  {
    "label": "leoNumber",
    "displayLabel": "Leo No",
    "editable": true,
    "placeholder": "Enter Leo No",
    "fieldInfo": {
      "dataType": "string"
    }
  },
  {
    "label": "leoDate",
    "displayLabel": "Leo Date",
    "editable": true,
    "placeholder": "Enter Leo Date",
    "fieldInfo": {
      "dataType": "datetime-local"
    }
  },
  {
    "label": "leoReferenceNumber",
    "displayLabel": "Reference No",
    "editable": true,
    "placeholder": "Enter Reference No.",
    "fieldInfo": {
      "dataType": "string"
    }
  },
  {
    "label": "accountHolder.name",
    "displayLabel": "Freight Forwarder",
    "editable": false
  },
  {
    "label": "exportCargoMetadata.invoiceNo",
    "displayLabel": "Invoice Number",
    "editable": false
  },
  {
    "label": "exportCargoMetadata.invoiceDate",
    "displayLabel": "Invoice Date",
    "editable": false
  }
]
